<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-09-01 10:56:47
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-08-10 16:44:59
 * @FilePath: \vue-app-console\src\views\AdvancedFunction\APPVersionList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Header :headerData="headerData"></Header>
        <!-- 页面内容整体下移间距 -->
        <div class="content_spacer"></div>
        <!-- 查询区 -->
        <div class="query_box query-box-uniform">
            <a-select 
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')"
                :options="searchTenantOptions"
                style="width:200px"
                @change="handleSelectChange('tenant')"
            ></a-select>
            <a-select 
                v-model:value="searchForm.platform" 
                :options="platformOptions" 
                allowClear 
                class="query_input query_field" 
                :placeholder="t('appVersion.platform')" 
                @change="handleSearch" 
            />
            <a-input 
                v-model:value="searchForm.version" 
                :placeholder="t('appVersion.currentVersion')" 
                allowClear
                class="query_input query_field" 
                @pressEnter="handleSearch"
            />
            <a-select 
                v-model:value="searchForm.alert_flag" 
                :options="alertFlagOptions" 
                allowClear 
                class="query_input query_field" 
                :placeholder="t('appVersion.alertFlag')" 
                @change="handleSearch" 
            />
            <a-select 
                v-model:value="searchForm.status" 
                :options="statusOptions" 
                allowClear 
                class="query_input query_field" 
                :placeholder="t('appVersion.status')" 
                @change="handleSearch" 
            />
            <a-button type="primary" size="small" @click="handleSearch">
                <component :is="$antIcons['SearchOutlined']" style="margin-right: 5px;margin-top:-3px" />
                {{ t('base.search') }}
            </a-button>
            <a-button type="primary" size="small" style="margin-left: 0;" @click="handleReset" v-if="false">
                <component :is="$antIcons['ReloadOutlined']" style="margin-right: 5px;margin-top:-3px" />
                {{ t('base.reset') }}
            </a-button>
        </div>

        <!-- 操作按钮 -->
        <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="openModal('add')">
                <component :is="$antIcons['PlusOutlined']" style="margin-right: 5px;margin-top:-3px" />
                {{ t('appVersion.add') }}
            </a-button>
        </div>

        <!-- 表格 -->
        <Table
            ref="tableRef"
            class="table"
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
        <template #customCol="{ props }">
            <template v-if="props.column.key === 'no'">
                {{ (table.configs.pagination.current - 1) * table.configs.pagination.pageSize + props.record.index + 1 }}
            </template>
            <template v-else-if="props.column.key === 'alert_flag'">
                {{ mapAlertFlag(props.record.alert_flag) }}
            </template>
            <template v-else-if="props.column.key === 'status'">
                {{ mapStatus(props.record.status) }}
            </template>
            <template v-else-if="props.column.key !== 'action'">
                {{ formatCell(props.record[props.column.dataIndex]) }}
            </template>
        </template>
        <template v-slot:tableAction="{props}">
        <template v-if="props.column.key === 'action'">
            <a-button size="small" type="primary" style="margin-right:10px"
            @click="openModal('copy', props.record)"
            >
            {{ t('appVersion.copy') }}
            </a-button>
            <a-button size="small"
            :disabled="props.record.status == 1"
            @click="handleCancel(props.record)"
            >
            {{ t('base.cancel') }}
            </a-button>
        </template>
        </template>
        </Table>

        <!-- 新增/编辑弹窗 -->
        <a-modal 
            v-model:open="modalVisible"
            :title="modalType === 'add' ? t('appVersion.add') : t('appVersion.add')"
            :width="600"
            centered
            :footer="null"
            class="appver-modal"
            :getContainer="false"
        >
            <div class="form form-horizontal">
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('appVersion.tenant') }}</label>
                    <a-select v-model:value="formData.tenant" :options="tenantOptions" allowClear class="form_input" />
                </div>
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('appVersion.platform') }}</label>
                    <a-select v-model:value="formData.platform" :options="platformOptions" allowClear class="form_input" />
                </div>
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('appVersion.platformPath') }}</label>
                    <a-input v-model:value="formData.platform_path" allowClear placeholder="Please Enter" class="form_input" :maxlength='500' show-count />
                </div>
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('appVersion.currentVersion') }}</label>
                    <a-input v-model:value="formData.version" allowClear placeholder="eg: 1.0.0" class="form_input" />
                </div>
                <div class="form_row">
                    <label class="form_label"><span class="required">*</span>{{ t('appVersion.alertFlag') }}</label>
                    <a-radio-group v-model:value="formData.alert_flag" class="form_input">
                        <a-radio value="YES">{{ t('appVersion.yes') }}</a-radio>
                        <a-radio value="NO">{{ t('appVersion.no') }}</a-radio>
                    </a-radio-group>
                </div>
                <div class="form_btns">
                    <a-button style="margin-right: 16px;" @click="modalVisible = false">{{ t('base.cancel') }}</a-button>
                    <a-button type="primary" @click="handleSubmit">{{ t('base.confirm') }}</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import Table from '@/components/Table.vue';
    import { APPVersionApi } from '@/api/AppVersionApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { message, Modal } from 'ant-design-vue';
    import Header from "@/layouts/component/Header.vue";
    import { getWeek } from '@/hooks/useGetWeek';
    import { useI18n } from 'vue-i18n';
    import { PlusOutlined, SearchOutlined, CopyOutlined, ReloadOutlined, StopOutlined } from '@ant-design/icons-vue';

    const { t } = useI18n();

    const headerData = ref({
        menu:'menu.appVersion',
        menu_desc: 'menu.subAppVersion',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    defineOptions({ name: 'APPVersionList' })

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const tableRef = ref(null);
    const normalizeFlag = (val) => {
    if (val === 0 || val === '0' || val === 'YES' || val === 'Yes' || val === 'yes' || val === true || val === 'Normal') return 0;
    if (val === 1 || val === '1' || val === 'NO' || val === 'No' || val === 'no' || val === false || val === 'Canceled') return 1;
    return val;
    };
    const mapAlertFlag = (val) => {
    const n = normalizeFlag(val);
    if (n === 0) return t('appVersion.yes');
    if (n === 1) return t('appVersion.no');
    // 统一空值显示为 '-'
    if (val === undefined || val === null || String(val).trim() === '') return '-';
        return String(val);
    };
    const mapStatus = (val) => {
    const n = normalizeFlag(val);
        if (n === 0) return t('appVersion.normal');
        if (n === 1) return t('appVersion.canceled');
        // 统一空值显示为 '-'
        if (val === undefined || val === null || String(val).trim() === '') return '-';
        return String(val);
    };

    // 统一格式化单元格：空值显示 '-'
    const formatCell = (val) => {
        if (val === undefined || val === null) return '-';
        const s = String(val);
        if (s.trim() === '') return '-';
        return s;
    };

    // 将标记统一映射为 YES / NO，便于表单单选框选中
    const flagToYesNo = (val) => {
    const n = normalizeFlag(val);
    if (n === 0) return 'YES';
    if (n === 1) return 'NO';
    return val ?? '';
    };

    const tenantOptions = ref([]);
    const tenantRawList = ref([]);
    const platformOptions = [
        { label: t('appVersion.android'), value: 'Android' },
        { label: t('appVersion.ios'), value: 'iOS' },
    ];
    const alertFlagOptions = [
        { label: t('appVersion.yes'), value: 'YES' },
        { label: t('appVersion.no'), value: 'NO' },
    ];
    const statusOptions = [
        { label: t('appVersion.normal'), value: 'Normal' },
        { label: t('appVersion.canceled'), value: 'Canceled' },
    ];

    const searchForm = reactive({
        tenant_id:null,
        platform: undefined,
        version: '',
        alert_flag: undefined,
        status: undefined
    });
    const searchTenantOptions = ref([])

const table = ref({
    data: [],
    columns: [
        // { title: t('appVersion.number'), dataIndex: 'no', key: 'no', width: 50 },
        { 
            title: t('appVersion.tenant'), dataIndex: 'tenant_name', key: 'tenant_name', width: 70, fixed: 'left',
            // filters: [
            //     {
            //         text: 'GOBAO',
            //         value: 'GOBAO',
            //     },
            //     {
            //         text: 'HEPHA',
            //         value: 'HEPHA',
            //     },
            //     {
            //         text: 'Corest',
            //         value: 'Corest',
            //     },
            //     {
            //         text: 'Birk',
            //         value: 'Birk',
            //     },
            // ],
            // filterMultiple: false,
            // onFilter: (value, record) => record.tenant_name.indexOf(value) === 0,
        },
        { title: t('appVersion.platform'), dataIndex: 'platform', key: 'platform', width: 80 },
        { title: t('appVersion.platformPath'), dataIndex: 'platform_path', key: 'platform_path', width: 160 },
        { title: t('appVersion.currentVersion'), dataIndex: 'current_version', key: 'current_version', width: 120 },
        { title: t('appVersion.releaseId'), dataIndex: 'release_id', key: 'release_id', width: 130 },
        { title: t('appVersion.alertFlag'), dataIndex: 'alert_flag', key: 'alert_flag', width: 90 },
        { title: t('appVersion.status'), dataIndex: 'status', key: 'status', width: 90 },
        { title: t('appVersion.createTime'), dataIndex: 'create_time', key: 'create_time', width: 140 },
        { title: t('base.operate'), key: 'action', width: 120, fixed: 'right' },
    ],
    configs: {
        table: {
            rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        },
        scroll: {
            x: 1300,
            y: 400,
        },
        rowSelection: false,
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
            position: ['bottomLeft'],
            showSizeChanger: true,
            pageSizeOptions: ['10','20','50'],
        },
        operateBtn: {
            showSearch: false,
            showAdd: false,
        }
    }
});

    const modalVisible = ref(false);
    const modalType = ref('add');
    const formData = reactive({
        tenant: '',
        platform: '',
        platform_path: '',
        version: '',
        alert_flag: ''
    });
    const copyRecord = ref(null);

    const fetchTableData = async () => {
        table.value.configs.loading = true;
        const page_num = table.value.configs.pagination.current;
        const page_size = table.value.configs.pagination.pageSize;
        const param = {
            teanant_id: searchForm.tenant_id,
            platform: searchForm.platform ?? '',
            current_version: searchForm.version.trim(),
            alert_flag: (searchForm.alert_flag ?? '') === '' ? '' : normalizeFlag(searchForm.alert_flag),
            status: (searchForm.status ?? '') === '' ? '' : normalizeFlag(searchForm.status)
        };
        const res = await APPVersionApi.getInstance().getAPPVersionList(param, page_num, page_size);
        if (res.code === 0) {
            table.value.data = res.data.records.map((item, idx) => ({ ...item, index: idx }));
            table.value.configs.pagination.total = res.data.total;
        } else {
            message.error(res.msg || t('base.getDataFail'));
        }
        table.value.configs.loading = false;
    };

    // 获取租户下拉
    const fetchTenantOptions = async () => {
        let param = {
            limit_size: 100,
        }
        const res = await APPVersionApi.getInstance().getTenant(param);
        if (res.code === 0 && Array.isArray(res.data)) {
            tenantRawList.value = res.data;
            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name ?? item.label ?? item.name ?? item.text ?? '',
                value: item.tenant_id ?? item.id ?? item.tenant ?? item.value ?? item.code ?? '',
            })).filter(opt => opt.label !== '' && opt.value !== '');

            searchTenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            searchTenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })
        }
    };

    const handleSearch = () => {
        table.value.configs.pagination.current = 1;
        fetchTableData();
    };

    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        fetchTableData()
    }

    const handleChangePagination = (config) => {
        table.value.configs.pagination.current = config.current;
        table.value.configs.pagination.pageSize = config.pageSize;
        // 仅在本页面：翻页或切换每页行数时，收起所有已展开的子表格
        try {
            if (tableRef.value && tableRef.value.expandedRowKeys) {
                tableRef.value.expandedRowKeys.value = [];
            }
        } catch (e) {}
        fetchTableData();
    };

    const handleReset = () => {
        searchForm.platform = undefined;
        searchForm.version = '';
        searchForm.alert_flag = undefined;
        searchForm.status = undefined;
        table.value.configs.pagination.current = 1;
        fetchTableData();
    };

    const openModal = (type, record = null) => {
        modalType.value = type;
        modalVisible.value = true;
        if (type === 'copy' && record) {
            if (record.tenant_id !== undefined && record.tenant_id !== null && record.tenant_id !== '') {
                formData.tenant = record.tenant_id;
            } else if (record.tenant !== undefined && record.tenant !== null && record.tenant !== '') {
                formData.tenant = record.tenant;
            } else if (record.tenant_name) {
                const match = (tenantOptions.value || []).find(opt => opt.label === record.tenant_name);
                formData.tenant = match ? match.value : record.tenant_name;
            } else {
                formData.tenant = '';
            }
            formData.platform = record.platform ?? '';
            formData.platform_path = record.platform_path ?? '';
            formData.version = record.current_version ?? record.version ?? '';
            formData.alert_flag = flagToYesNo(record.alert_flag ?? '');
            if ('status' in formData && 'status' in record) {
                formData.status = record.status;
            }
            copyRecord.value = record;
        } else {
            formData.tenant = '';
            formData.platform = '';
            formData.platform_path = '';
            formData.version = '';
            formData.alert_flag = '';
            if ('status' in formData) {
                formData.status = '';
            }
            copyRecord.value = null;
        }
    };

    const handleCancel = (record) => {
        Modal.confirm({
            title: t('appVersion.cancelTitle'),
            content: t('appVersion.confirmCancel'),
            okText: t('base.confirm'),
            cancelText: t('base.cancel'),
            onOk: async () => {
                try {
                    // 获取 user_id
                    let userInfo = sessionStorage.getItem('userInfo');
                    let user_id = '';
                    if (userInfo) {
                        try {
                            userInfo = JSON.parse(userInfo);
                            user_id = userInfo.id;
                        } catch (e) {
                            user_id = '';
                        }
                    }
                    const res = await APPVersionApi.getInstance().cancelAPPVersion(user_id, record.id);
                    if (res.code === 0) {
                        message.success(t('base.operateSuccess'));
                        fetchTableData(); // 刷新表格数据
                    } else {
                        message.error(res.msg || t('base.operateFail'));
                    }
                } catch (error) {
                    console.error('Cancel error:', error);
                    message.error(t('appVersion.cancelFailed') + ': ' + error.message);
                }
            }
        });
    };

    const handleSubmit = async () => {
        // 统一获取 tenant 显示名与 id
        const tenantMatch = (tenantOptions.value || []).find(opt => opt.value === formData.tenant || opt.label === formData.tenant);
        const tenant_id = tenantMatch ? tenantMatch.value : '';
        const tenantLabel = tenantMatch ? tenantMatch.label : '';
        
        if (tenant_id === '' || tenant_id === null || tenant_id === undefined) {
            message.error(t('appVersion.tenantRequired'));
            return;
        }
        if (!formData.platform) {
            message.error(t('appVersion.platformRequired'));
            return;
        }
        if (!formData.platform_path) {
            message.error(t('appVersion.platformPathRequired'));
            return;
        }
        if (!formData.version) {
            message.error(t('appVersion.versionRequired'));
            return;
        }
        if (!formData.alert_flag) {
            message.error(t('appVersion.alertFlagRequired'));
            return;
        }

        const tenantRaw = (tenantRawList.value || []).find(item => (
            item.tenant_id == tenant_id ||
            item.id == tenant_id ||
            item.tenant_name === tenantLabel ||
            item.label === tenantLabel ||
            item.tenant == tenant_id ||
            item.value == tenant_id
        )) || {};

        const tenantCode = tenantRaw.tenant_code || tenantRaw.code || tenantRaw.tenant || '';

        const param = {
            teanant_id: tenant_id,
            platform: formData.platform,
            platform_path: formData.platform_path,
            current_version: formData.version,
            alert_flag: normalizeFlag(formData.alert_flag)
        };
        
        const res = await APPVersionApi.getInstance().addAPPVersion(param);
        if (res.code === 0) {
            message.success(t('base.operateSuccess'));
            modalVisible.value = false;
            fetchTableData();
        } else {
            message.error(res.msg || t('base.operateFail'));
        }
    };

    onMounted(() => {
        fetchTableData();
        fetchTenantOptions();
    });
</script>

<style lang="scss" scoped>
.query_box {
    margin: 20px 0 10px 0;
}
.operate_btn {
    margin-bottom: 10px;
}
.form {
    .form_item {
        margin-bottom: 15px;
        .form_item_label {
            font-size: 16px;
            font-weight: 600;
        }
        .required {
            color: red;
        }
    }
}
.createBtnDiv {
    text-align: center;
    .createBtn {
        margin: 20px 0 10px;
        width: 200px;
        text-align: center;
    }
}
.form-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.form-center .form_item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.form-center .form_item_label {
    align-self: flex-start;
}
.form-horizontal {
    width: 100%;
    margin: 0 auto;
    padding: 10px 0 0 0;
}
.form_row {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
}
.form_label {
    width: 130px;
    text-align: right;
    font-size: 16px;
    font-weight: 600;
    margin-right: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
}
.required {
    color: #ff4d4f;
    margin-right: 4px;
    font-size: 16px;
    font-family: inherit;
}
.form_input {
    flex: 1;
    min-width: 300px;
    max-width: 380px;
}
.form_btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
.query-box-uniform {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: 20px 0 10px 0;
}
.query_input {
    width: 200px;
}

// .query_box{
//     margin-top: 30px;
//     margin-bottom: 20px;

//     .query_field{
//         display: inline-block;
//         margin-right: 10px;
//         margin-bottom: 5px;
//         width: 200px;
//     }
// }

/* 统一表格行距（参考 Access/Account 页面） */
::v-deep .ant-table-wrapper .ant-table-thead>tr>th,
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td,
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

/* 页面顶部下移 */
.content_spacer{
    height: 30px;
}

/* 调整week位置，使其与AccountMTG保持一致 */
:deep(.page_header .week) {
    margin-top: -48px !important;
}

:deep(.page_header .admin_email) {
    margin-top: -37.5px !important;
    margin-right: 70px !important;
}

/* Center Add/Copy modal title */
::v-deep(.appver-modal .ant-modal-header){
    display: flex;
    justify-content: center;
}
::v-deep(.appver-modal .ant-modal-title){
    text-align: center;
}

</style>